'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var BufferList = require('bl/BufferList');

var varintEncode = require('./varint-encode');

var MIN_POOL_SIZE = 8; // Varint.encode(Number.MAX_SAFE_INTEGER).length

var DEFAULT_POOL_SIZE = 10 * 1024;

function encode(options) {
  options = options || {};
  var poolSize = Math.max(options.poolSize || DEFAULT_POOL_SIZE, options.minPoolSize || MIN_POOL_SIZE);
  var encodeLength = options.lengthEncoder || varintEncode;
  return function (source) {
    return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var pool, poolOffset, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, encodedLength;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pool = Buffer.alloc(poolSize);
              poolOffset = 0;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 4;
              _iterator = _asyncIterator(source);

            case 6:
              _context.next = 8;
              return _awaitAsyncGenerator(_iterator.next());

            case 8:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 12;
              return _awaitAsyncGenerator(_step.value);

            case 12:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 24;
                break;
              }

              chunk = _value;
              encodeLength(chunk.length, pool, poolOffset);
              encodedLength = pool.slice(poolOffset, poolOffset + encodeLength.bytes);
              poolOffset += encodeLength.bytes;

              if (pool.length - poolOffset < MIN_POOL_SIZE) {
                pool = Buffer.alloc(poolSize);
                poolOffset = 0;
              }

              _context.next = 21;
              return new BufferList().append(encodedLength).append(chunk);

            case 21:
              _iteratorNormalCompletion = true;
              _context.next = 6;
              break;

            case 24:
              _context.next = 30;
              break;

            case 26:
              _context.prev = 26;
              _context.t0 = _context["catch"](4);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 30:
              _context.prev = 30;
              _context.prev = 31;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 35;
                break;
              }

              _context.next = 35;
              return _awaitAsyncGenerator(_iterator.return());

            case 35:
              _context.prev = 35;

              if (!_didIteratorError) {
                _context.next = 38;
                break;
              }

              throw _iteratorError;

            case 38:
              return _context.finish(35);

            case 39:
              return _context.finish(30);

            case 40:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 26, 30, 40], [31,, 35, 39]]);
    }))();
  };
}

encode.single = function (chunk, options) {
  options = options || {};
  var encodeLength = options.lengthEncoder || varintEncode;
  return new BufferList([encodeLength(chunk.length), chunk]);
};

module.exports = encode;
module.exports.MIN_POOL_SIZE = MIN_POOL_SIZE;
module.exports.DEFAULT_POOL_SIZE = DEFAULT_POOL_SIZE;